var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible('EditForceUpdateConfigDialog'))?_c('EditForceUpdateConfigDialog'):_vm._e(),(_vm.visible('EditHotUpdateConfigDialog'))?_c('EditHotUpdateConfigDialog'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }